<!--  

MOSTRA DETALHES DA AGENDA DO NEGOCIO  

-->


<script>

// import CrmFunilNovo from './crm-pessoa-novo-form'
import { SysVars } from '../main';

export default {

    props: {
      index: '',
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,
            negociocrm: null,
            showFormAgenda: false,
            codagenda: null,
            loading: true,
        }
    },

    computed: {

        agendaList: function () {
            if (!this.negociocrm)
                return []
            else
                return this.negociocrm.agenda
        },

    },

    watch: {

    },

    filters: {

    },

    methods: {
        closeForm () {
            console.log('closeform')
        },
        
        handleAdicionarAgenda () {
            this.$emit('adicionarAgenda', this.negociocrm)
        },

        handleEditAgenda (codagenda) {
            this.$emit('editAgenda', this.negociocrm, codagenda)
        },

        async loadData () {
            await this.$store.dispatch('loadNegocio', { id: this.index } )
            if (this.$store.getters.getNegocio) {
                this.negociocrm = {...this.$store.getters.getNegocio}
            }
            this.loading = false
        },
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
    <div class="card-pop" style="width: 300px; position: absolute; will-change: transform; transform: translate3d(205px, -50px, 0px);">
        <div class="card-pop-inner">
            <div class="card-dropdown">
                <div v-if="!loading" class="card-dropdown__content">
                    <div class="row text-center mx-auto" v-if="agendaList.length == 0">
                        <div class="no-content mt-5 mb-5">
                            Nenhuma atividade foi agendada para este negócio
                        </div>
                    </div>
                    <div class="mainbox" v-for="(item, index) in agendaList" :key="index">
                        <div class="box">
                            <div class="row align-items-center">
                                <div class="col-md-2 col-2 text-center">
                                    <i v-if="item.tpagenda == 'L'" class="fa fa-phone" style="font-size: 28px"></i>
                                    <i v-if="item.tpagenda == 'V'" class="fa fa-car" style="font-size: 28px"></i>
                                    <i v-if="item.tpagenda == 'A'" class="fa fa-tasks" style="font-size: 28px"></i>
                                </div>
                                <div class="col-md-10 col-8" @click="handleEditAgenda(item.codagenda)" style="cursor: pointer">
                                    <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ item.dataagendada | formatDataExtenso }}</span>
                                    <!-- <span class="lbl-list pr-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> Criado por {{ item.usuario_nome }}</span> -->
                                    <span class="data-list mb-2 error" v-if="item.dias_atraso > 0">Astrasada {{ item.dias_atraso | formatValue(0) }} dias</span>
                                    <span class="data-list w-100">{{ item.titulo }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3 text-center">
                        <v-button label="Criar uma atividade" icon="fa-plus" @click="handleAdicionarAgenda()"></v-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style>


.card-pop {
    display: inline-flex;
    align-items: center;
    visibility: visible;
    top: 0;
    left: 0;
    position: relative;
    z-index: 1;
    flex-direction: row;
}

.card-pop-inner {
    max-width: 640px;
    font: 400 15px/20px Source Sans Pro,sans-serif;
    color: #26292c;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 2px 0 rgba(0,0,0,.24), 0 8px 10px 1px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.06), 0 5px 5px -3px rgba(0,0,0,.1);
    order: 2;
}

.card-pop-inner, .card-pop-inner>.cui4-spacing {
    overflow: hidden;
    overflow-wrap: break-word;
}

.cui4-spacing {
    display: block;
}

.card-dropdown {
    max-height: 100%;
    display: flex;
    flex-direction: column;
}

.card-dropdown__content {
    overflow-y: auto;
    flex: 1 1 auto;
    padding: 8px 0;
}

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-card-detalhe.vue